<template>
  <div class="periodontal-page">
    <div class="risk-map-page__wrapper">
      <w-report-header />

      <risk-map-new></risk-map-new>

      <!--      TODO: Создать подобный компонент для страницы карты рисков и внедрить-->
      <!--      <e-old-recommendations-->
      <!--        :consultation="consultation"-->
      <!--        class="old-report-page__card"-->

      <!--      TODO: Переделать компонент снизу для страницы карты рисков-->
      <!--      <w-report-comments-->
      <!--        :key="comments"-->
      <!--        :comments="comments"-->
      <!--        :report-type="REPORT_VIEW.riskMap"-->
      <!--        class="old-report-page__card"-->
      <!--        is-old-->
      <!--      />-->
    </div>
  </div>
</template>

<script lang="ts">

</script>

<style lang="scss" scoped>
.risk-map-page {
  display: flex;
  justify-content: center;
  overflow-y: auto;
  padding: 16px 25px 0 18px;
  width: 100%;
  height: 100%;

  &__wrapper {
    width: 100%;
    max-width: 938px;
  }

  &__pdf {
    position: absolute;
    top: 0;
    z-index: -1;
    opacity: 0;
  }

  &__card {
    margin-bottom: 26px;
  }
}
</style>
